import { render, staticRenderFns } from "./user_bzzx.vue?vue&type=template&id=4edba56a&scoped=true"
import script from "./user_bzzx.vue?vue&type=script&lang=js"
export * from "./user_bzzx.vue?vue&type=script&lang=js"
import style0 from "./user_bzzx.vue?vue&type=style&index=0&id=4edba56a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edba56a",
  null
  
)

export default component.exports